import ChallengesService from "@/api/services/challenges";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.challenges;
      state.currentPage = data.page?.currentPage || 1;
      state.totalPages = data.page?.totalPages || 0;
      state.totalCount = data.page?.totalCount || 0;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
  },
  actions: {
    async fetchIndex({ commit }, { includes = [], page, perPage } = {}) {
      const response = await ChallengesService.fetchIndex({ includes, page, perPage });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async fetch(_, { challengeId, includes = [] }) {
      return await ChallengesService.fetch(challengeId, includes);
    },
    async update(_, { challengeId, payload }) {
      return await ChallengesService.update(challengeId, payload);
    },
    async delete(_, challengeId) {
      return await ChallengesService.delete(challengeId);
    },
    async addOrganizations(_, { challengeId, organizations }) {
      return await ChallengesService.addOrganizations(challengeId, organizations);
    },
    async create(_, data) {
      return await ChallengesService.create(data);
    },
    async downloadReporting(_, { challengeId, storeIds }) {
      return await ChallengesService.downloadReporting(challengeId, storeIds);
    },
    async getPerformance(_, { storeId, challengeId }) {
      return await ChallengesService.getPerformance(storeId, challengeId);
    },
  },
};
